import { render, staticRenderFns } from "./QuestionListeningSpell.vue?vue&type=template&id=66179af2&scoped=true"
import script from "./QuestionListeningSpell.vue?vue&type=script&lang=js"
export * from "./QuestionListeningSpell.vue?vue&type=script&lang=js"
import style0 from "./QuestionListeningSpell.vue?vue&type=style&index=0&id=66179af2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66179af2",
  null
  
)

export default component.exports